import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectOnlineFormContract } from 'stores/onlineForm/onlineForm';
import { getLifewayConsultant } from 'apis/Lifeway';
import { Date, Money } from 'modules';
import { bonatoCompany, lifewayCompany } from 'constants/company';

const ContentLifeway = () => {
  const [lifeway, setLifeway] = useState<any>();
  const contract = useSelector(selectOnlineFormContract);

  useEffect(() => {
    if (contract?.id) {
      getLifewayConsultant(contract.id).then(setLifeway);
    }
  }, [contract]);

  const consultant = useMemo(() => contract?.consultant2, [contract]);

  return (
    <div style={{ lineHeight: '170%' }}>
      <div className="mb-3 text-center">
        <strong>OBJEDNÁVKA NA ODDLŽENIE BONATO č. {contract?.cislo}</strong>
        <br />
        <strong>REGISTRAČNÉ VYHLÁSENIE</strong>
      </div>

      {lifeway && (
        <>
          <div className="mb-3">
            Já:{' '}
            <strong>
              {lifeway?.lastName} {lifeway?.firstName}
            </strong>
            <br />
            e-mail: {lifeway?.email}
            <br />
            mobil: {lifeway?.mobileNumberPrefix}
            {lifeway?.mobileNumber}
            <br />
            Adresa: {lifeway?.permanentAddress?.street} {lifeway?.permanentAddress?.houseNumber}, PSČ{' '}
            {lifeway?.permanentAddress?.zipCode}, {lifeway?.permanentAddress?.city}
            <br />
          </div>

          <div className="mb-3">
            <div className="mb-2">
              prehlasujem, že mi Oddlžovací poradca {consultant?.prijmeni} {consultant?.jmeno}{' '}
              <Date value={contract?.datum} /> vysvetlil základné výhody členstva v komunite LIFEWAY Slobodne som sa
              rozhodol stať sa členom komunity LIFEWAY, ktorú prevádzkuje spoločnosť {lifewayCompany.name}, so sídlom{' '}
              {lifewayCompany.address}, IČO: {lifewayCompany.ic}, DIČ: {lifewayCompany.dic}, e-mail:
              {lifewayCompany.email}, webstránka: {lifewayCompany.website}
            </div>

            <div className="mb-2 text-indent">
              Moja pozícia Člena komunity LIFEWAY je <strong>{lifeway?.position?.name}</strong>
            </div>

            <div className="mb-2">
              Po uhradení jednorazového členského príspevku{' '}
              <strong>
                <Money value={lifeway?.position?.registrationFee} />
              </strong>{' '}
              mi bude úplne sprístupnená členská sekcia MOJE LIFEWAY BONATO na {lifewayCompany.website} zaslaním
              prístupového mena a hesla na môj e-mail uvedený v tomto registračnom prehlásení.
            </div>
            <div className="mb-2 text-indent">
              Zároveň mi zo strany obchodnej spoločnosti {bonatoCompany.name}, so sídlom{' '}
              {bonatoCompany.residenceAddress}, IČO: {bonatoCompany.ic}, DIČ: {bonatoCompany.dic} bude vypracovaný návrh
              riešenia - správa o zhodnotení, ktoré z finančných záväzkov je vhodné vziať do správy záväzkov a ktoré nie
              a to do 7 pracovných dní od doručenia všetkých dokladov, ktoré uvedená obchodná spoločnosť bude odo mňa
              vyžadovať.
            </div>

            <div className="mb-2 text-indent">
              Obchodná spoločnosť {lifewayCompany.name}, spolupracuje s obchodnou spoločnosťou {bonatoCompany.name},
              ktorej hlavným krédom je podať pomocnú ruku dlžníkovi, ktorý sa vplyvom nepriaznivých životných udalostí
              ocitol v dlhovej pasci a zabezpečiť mu skutočnú úľavu od dlhov a stratenú radosť zo života a to
              prostredníctvom produktov a služieb súvisiacich s oddlžením fyzických osôb, predstavuje teda spoľahlivého
              a ústretového partnera.
            </div>

            <div className="mb-2 text-indent">
              Ďalej prehlasujem, že sa zúčastním „Základného seminára“, na ktorý budem pozvaný a ktorý sa koná raz za
              mesiac formou on line. Na základnom seminári sa dozviem všetky potrebné informácie o tom, ako môžem ihneď
              začať zvyšovať svoj mesačný príjem. Je mi jasné, že každá sekcia je špecifická a preto súhlasím s tým, že
              absolvujem školenia na jednotlivé sekcie, aby som mohol využívať výhody členstva naplno.
            </div>

            <div className="mb-2 text-indent">
              Ďalej potvrdzujem podpisom tohto registračného prehlásenia, že som sa oboznámil so všeobecnými obchodnými
              podmienkami LIFEWAY BONATO, ktoré sú umiestnené na:{' '}
              <a href="https://belifeway.com/vop/" target="_blank" rel="noopener noreferrer">
                https://belifeway.com/vop/
              </a>{' '}
              a kde sú špecifikované všetky ostatné dojednania.
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ContentLifeway;
